import dialogs from '../common/dialogs.js'
import action from './Action.js'
import store from '../../store'

import vActionProp from './ActionProp.vue'

export default {
  createStrategy (cxt, type) {
    switch (type) {
      case 'ACTION': {
        return action.createStrategy(cxt)
      }
    }
  },
  openLogAction (itemId, resourceId) {
    return new Promise((resolve, reject) => {
      let strategy = this.createStrategy(null, 'ACTION')
      this.openPropStg(strategy, itemId, resourceId).then(data => {
        resolve(data)
      })
    })
  },
  openPropStg (strategy, itemId, resourceId) {
    return new Promise((resolve, reject) => {
      dialogs.register('v-action-prop', vActionProp)
      var fullscreen = store.getters.getIsMobile
      strategy.updateSteps()
      var comp = { template: `
        <v-action-prop
        :itemId="itemId"
        :resourceId="resourceId"
        :strategy="strategy"
        v-on:close="onClose"
        :fullscreen="fullscreen"></v-action-prop>
        `,
        data () {
          return {
            fullscreen: fullscreen,
            itemId: itemId ? itemId.toString() : null,
            resourceId: resourceId ? resourceId.toString() : null,
            strategy: strategy,
            onClose: () => {
              this.$emit('close')
              resolve()
            }
          }
        }}
      dialogs.modal(comp)
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/profile/index.js